<template>
  <div>
    <el-form>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="人员选择" prop="">
            <userSelect :list="userList" :type="2"></userSelect>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="人员信息" prop="">
            <userInfoList :obj="userObj" :type="0"></userInfoList>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="部门选择" prop="">
            <deptSelect :dept-info="{ deptName: '产品研究院', deptId: '1' }"></deptSelect>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="部门信息" prop="">
            <deptInfoList :dept-id="'1'" :dept-name="'产品研究院'"></deptInfoList>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="字典选择" prop="">
            <dicListSelect :dic-code="'QueStatus'" :value="'QueStatus001'"></dicListSelect>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import deptInfoList from "@/CommonDP/components/commonComponents/deptInfoList.vue";
import deptSelect from "@/CommonDP/components/commonComponents/deptSelect.vue";
import userInfoList from "@/CommonDP/components/commonComponents/userInfoList.vue";
import userSelect from "@/CommonDP/components/commonComponents/userSelect.vue";
import dicListSelect from "@/CommonDP/components/commonComponents/dicListSelect.vue";
export default {
  components: { deptInfoList, deptSelect, userInfoList, userSelect, dicListSelect },
  props: {},
  data() {
    return {
      userList: [],
      userObj: {}
    };
  },
  computed: {}
};
</script>

